import React, {useEffect, useState} from 'react';
import {Event} from "types/Event";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import RadioGroup from "components/Form/RadioGroup";
import {useOperator} from "context/OperatorContext";

type Props = {
    event: Event | null
    show: boolean
    onDelete?: (event: Event) => any
    onDeleteFail?: (event: Event, error: unknown) => any
    onCancel?: () => any
}

function DeleteEvent(props: Props) {
    const {termFor} = useOperator()
    const {event, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(event?.name || `this ${termFor('event')}`);
    const [isRecurring, setIsRecurring] = useState<boolean>(false);
    const [shouldDeleteSeries, setShouldDeleteSeries] = useState<boolean>(true);

    const {mutateAsync: deleteEvent} = useMutation(ngage.events.destroy)
    const {mutateAsync: deleteEventSeries} = useMutation(ngage.eventSeries.destroy)

    useEffect(() => {
        if(event) {
            setName(event.name)
            setIsRecurring(event.is_recurring)
        }
    }, [event]);

    async function handleDeleteEvent() {
        if (event) {
            try {
                shouldDeleteSeries? await deleteEventSeries(event.id) : await deleteEvent(event.id)
                await invalidate('events.all')

                if (onDelete) onDelete(event)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(event, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title={isRecurring? `Delete Recurring ${termFor('event')}` : `Delete ${termFor('event')}`}
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteEvent}
            onCancel={handleCancel}
        >
            {isRecurring &&
                <RadioGroup
                    label="Delete Mode"
                    selectedId={1}
                    items={[
                        // {id: 0, name: `Delete this ${termFor('event')} only`},
                        {id: 1, name: `Delete all ${termFor('events')} in this series`},
                    ]}
                    onChange={selectedId => setShouldDeleteSeries(selectedId === 1)}
                />
            }
        </ConfirmModal>
    );
}

export default DeleteEvent;